// 開きの支点はexpand-origin.tsがトリガー矩形（トリガーの位置に開く場合）または
// カーソル座標で上書きし、どちらも取れなければ各Popupの
// origin-(--transform-origin)=アンカー基点に任せる。
// transition-noneは維持必須: duration-*はtransition-durationも設定するため、
// Positionerが後付けする--anchor-width由来のminWidth変化まで幅アニメーションしてしまう。
const MENU_SIDE_ANIMATION_CLASS =
  "transition-none data-closed:pointer-events-none data-open:animate-menu-in data-closed:animate-menu-out";

const MENU_CONTENT_SURFACE_CLASS =
  "border-0 shadow-[0_10px_28px_var(--shadow-color-strong)] ring-0 outline-hidden";

type OverlayOffsetData = {
  side: "top" | "bottom" | "left" | "right" | "inline-start" | "inline-end";
  anchor: { height: number; width: number };
};

// トリガーの下ではなく、トリガーの位置にContentを出すためのsideOffset。
// side=bottomならContent上端=トリガー上端、画面下端でflipしてside=topになっても
// Content下端=トリガー下端になる。横方向へ開く場合は重ねずに隣へ出す。
const ADJACENT_SIDE_OFFSET = 4;

function triggerOverlaySideOffset({ anchor, side }: OverlayOffsetData) {
  return side === "top" || side === "bottom"
    ? -anchor.height
    : ADJACENT_SIDE_OFFSET;
}

// トリガーがContentへ遷移する見せ方にできる条件。呼出側がsideOffsetを指定した場合や
// anchorを別要素・座標へ向けた場合はContentがトリガーに重ならないので対象外。
function isTriggerOverlayPlacement({
  anchor,
  side,
  sideOffset,
}: {
  anchor?: unknown;
  side?: string | undefined;
  sideOffset?: unknown;
}) {
  return (
    anchor == null &&
    sideOffset === triggerOverlaySideOffset &&
    (side === undefined || side === "top" || side === "bottom")
  );
}

export {
  isTriggerOverlayPlacement,
  MENU_CONTENT_SURFACE_CLASS,
  MENU_SIDE_ANIMATION_CLASS,
  triggerOverlaySideOffset,
};
